import React, { useRef, useState } from 'react';
import { useElectronicSignatureProcessContext } from '../../../../../../../../dynamic_form/dynamic_form_types/ElectronicSignatureProcess/context/ElectronicSignatureProcessContext';
import ElectronicSignatureTable from '../../../../../../../../dynamic_form/dynamic_form_types/ElectronicSignatureProcess/componets/ElectronicSignatureTable';
import CredentialsModal from '../../../../../../../../dynamic_form/dynamic_form_types/ElectronicSignatureProcess/credentialsModal/CredentialsModal';
import { Button, Form } from 'react-bootstrap';
import { electronicSignatureSettingsFirel } from '../../../../../../../../dynamic_form/dynamic_form_types/ElectronicSignatureProcess/constants/electronicSignatureSettingsFirel';
import moment from 'moment';
import { secondCustomHeaderDatePicker } from '../../../../../../expedient_details_logic';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import { isWeekday } from '../../../../../CustomInputDate/CustomDateRules';
import CustomInputDate from '../../../../../CustomInputDate/CustomInputDate';
import { renderErrorsList } from '../../../../../../../../edit_profile/edit_profile_logic';
registerLocale('es', es);
const BodyModal = ({
  documentParameters,
  setDocumentParameters,
  dateIsAccepted,
  setDateIsAccepted,
  datePickerIsEnabled,
  holiday,
  errors,
  setErrors,
  isElectronicSignatureTableShowing,
  isOnlyOneSignaturePerUserActivated = true,
}) => {
  const {
    isElectronicSignatureModalSowing,
    setIsElectronicSignatureModalSowing,
    electronicSignaturesList,
    onCloseModal,
    onAddElectronicSignature,
    isMultipleSignature,
    onDelteElectronicSignatureById,
    singleElectronicSignature,
    isThereASignature,
    electronicSignaturesRecentlyAddedList,
    isThereASignatureRecentlyAdded,
  } = useElectronicSignatureProcessContext();
  const isSingleSignaturePresent = isThereASignature && !isMultipleSignature;
  const areThereMultipleSignatureRecentlyAdded =
    isThereASignatureRecentlyAdded && isMultipleSignature;
  const canASignatureBeAdded = !isSingleSignaturePresent && !areThereMultipleSignatureRecentlyAdded;
  const firstInputDatePicker = useRef(null);

  return (
    <>
      {isElectronicSignatureModalSowing && (
        <CredentialsModal
          isModalSowing={isElectronicSignatureModalSowing}
          onCloseModal={onCloseModal}
          addElectronicSignatureHandle={onAddElectronicSignature}
          isMultipleSignature={isMultipleSignature}
          electronicSignatureSettings={electronicSignatureSettingsFirel}
          isOnlyOneSignaturePerUserActivated={isOnlyOneSignaturePerUserActivated}
        />
      )}

      <Button
        variant="success"
        onClick={() => setIsElectronicSignatureModalSowing(true)}
        className={'mb-3'}
        style={{ marginTop: '20px' }}
      >
        {canASignatureBeAdded ? 'Agregar Firma' : 'Cambiar Firma'}
      </Button>

      {isElectronicSignatureTableShowing && (
        <>
          <p className="m-0">{isMultipleSignature ? 'Lista de Firmantes' : 'Firmante'}</p>
          <ElectronicSignatureTable
            electronicSignaturesList={electronicSignaturesList}
            electronicSignaturesRecentlyAddedList={electronicSignaturesRecentlyAddedList}
            singleElectronicSignature={singleElectronicSignature}
            isMultipleSignature={isMultipleSignature}
            onDelteElectronicSignatureById={onDelteElectronicSignatureById}
          />
        </>
      )}

      {(documentParameters['document_type'] === 'judgment' ||
        documentParameters['document_type'] === 'agreement' ||
        documentParameters['document_type'] === 'audience' ||
        documentParameters['document_type'] === 'certification' ||
        documentParameters['document_type'] === 'convention') &&
        documentParameters['ifexcerpt'] && (
          <Form.Group>
            <Form.Label>* Fecha de publicación a boletín:</Form.Label>
            <DatePicker
              renderCustomHeader={({
                date,
                changeYear,
                changeMonth,
                decreaseMonth,
                increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled,
              }) =>
                secondCustomHeaderDatePicker(
                  date,
                  changeYear,
                  changeMonth,
                  decreaseMonth,
                  increaseMonth,
                  prevMonthButtonDisabled,
                  nextMonthButtonDisabled
                )
              }
              dateFormat="dd/MM/yyyy"
              locale="es"
              minDate={new Date()}
              filterDate={
                documentParameters &&
                documentParameters.expedient.kind_judgment_id === 59 &&
                documentParameters.expedient.matter === 'laboral'
                  ? undefined
                  : isWeekday
              }
              excludeDates={
                documentParameters &&
                documentParameters.expedient.kind_judgment_id === 59 &&
                documentParameters.expedient.matter === 'laboral'
                  ? undefined
                  : holiday
              }
              customInput={<CustomInputDate ref={firstInputDatePicker} />}
              selected={
                documentParameters['publish_date']
                  ? moment(documentParameters['publish_date']).toDate()
                  : ''
              }
              disabled={!datePickerIsEnabled}
              onChange={(date) => {
                setDocumentParameters({
                  ...documentParameters,
                  publish_date: date,
                });
                setErrors({
                  ...errors,
                  publish_date: [],
                });
                setDateIsAccepted(false);
              }}
            />
            {documentParameters['publish_date'] && (
              <>
                <p className="text-xs">
                  Elegiste el día: {moment(documentParameters['publish_date']).format('DD/MM/YYYY')}
                </p>
                {!dateIsAccepted && (
                  <div className="">
                    <p>¿Estás seguro de que deseas continuar?</p>
                    <span>
                      <button
                        type="button"
                        className="btn btn-xs btn-success ml-2"
                        onClick={() => {
                          setDateIsAccepted(true);
                        }}
                      >
                        Aceptar
                      </button>
                      <button
                        className="btn btn-xs btn-error ml-2"
                        type="button"
                        onClick={() => {
                          setDocumentParameters({
                            ...documentParameters,
                            publish_date: '',
                          });
                          setDateIsAccepted(false);
                        }}
                      >
                        Cancelar
                      </button>
                    </span>
                  </div>
                )}
              </>
            )}
          </Form.Group>
        )}
      {renderErrorsList(errors, 'publish_date')}
    </>
  );
};

export default BodyModal;
